import { createContext, useContext } from 'react';

export const PortalContainerContext = createContext<HTMLElement | undefined>(undefined);

export const PortalContainerProvider = ({
    children,
    container,
}: {
    children: React.ReactNode;
    container: HTMLElement | undefined;
}) => {
    return <PortalContainerContext.Provider value={container}>{children}</PortalContainerContext.Provider>;
};

export const usePortalContainer = () => {
    return useContext(PortalContainerContext);
};
